var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionIconBox = function SvgQuestionIconBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26160_72024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5878 9.54904V9.54904C10.8737 8.48211 11.9704 7.84894 13.0373 8.13483C14.1043 8.42071 14.7374 9.51738 14.4515 10.5843C14.1657 11.6512 13.069 12.2844 12.002 11.9985",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6118 13.4489L12 12",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27207 13.5336L4.34262 5.80619L4.34262 5.80619C5.05733 3.13887 7.79902 1.55595 10.4663 2.27066L18.1938 4.34121V4.34121C20.8611 5.05592 22.444 7.79761 21.7293 10.4649L19.6587 18.1923V18.1923C18.944 20.8597 16.2023 22.4426 13.535 21.7279V21.7279L5.80761 19.6573L5.80761 19.6573C3.14028 18.9426 1.55736 16.2009 2.27207 13.5336L2.27207 13.5336Z",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.978 15.8137V15.8137C10.9513 15.8066 10.9239 15.8224 10.9167 15.8491C10.9096 15.8758 10.9254 15.9032 10.9521 15.9103C10.9788 15.9175 11.0062 15.9016 11.0133 15.875C11.0205 15.8483 11.0047 15.8209 10.978 15.8137V15.8137",
    stroke: "#C2E550",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26160_72024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgQuestionIconBox as ReactComponent };
export default __webpack_public_path__ + "question-icon-box.svg";